export class DeviationFilter {
    hours = 0;
    minutes = 5;
    seconds = 0;

    private _useHours = true;

    constructor(useHours = true) {
        this._useHours = useHours;
    }

    public get totalSeconds() {
        return (this._useHours ? (this.hours * 3600) : 0) + this.minutes * 60 + this.seconds;
    }

    public increase() {
        const selectedDeviationTotalSeconds = this.totalSeconds;
        const secondsToAdd = 15 - (selectedDeviationTotalSeconds % 15);
        const newDeviationTotalSeconds = selectedDeviationTotalSeconds + secondsToAdd;
        this.hours = Math.floor(newDeviationTotalSeconds / 3600);
        const remainingSeconds = newDeviationTotalSeconds - this.hours * 3600;
        this.minutes = Math.floor(remainingSeconds / 60);
        this.seconds = remainingSeconds % 60;
    }

    public decrease() {
        const selectedDeviationTotalSeconds = this.totalSeconds;

        let secondsToRemove = selectedDeviationTotalSeconds % 15;
        if (secondsToRemove === 0) {
            secondsToRemove = 15;
        }

        const newDeviationTotalSeconds = selectedDeviationTotalSeconds - secondsToRemove;

        if (newDeviationTotalSeconds <= 0) {
            this.hours = 0;
            this.minutes = 0;
            this.seconds = 0;
            return;
        }

        this.hours = Math.floor(newDeviationTotalSeconds / 3600); // Update hours
        const remainingSeconds = newDeviationTotalSeconds - this.hours * 3600; // Calculate remaining seconds after adjusting hours
        this.minutes = Math.floor(remainingSeconds / 60);
        this.seconds = remainingSeconds % 60;
    }

    public updateDeviation(hours: number, minutes: number, seconds: number) {
        this.hours = hours;

        if (seconds >= 60) {
            const additionalMinutes = Math.floor(seconds / 60);
            minutes += additionalMinutes;
            seconds %= 60;
        }

        if (minutes >= 60) {
            const additionalHours = Math.floor(minutes / 60);
            hours += additionalHours;
            minutes %= 60;
        }
        this.hours = hours;
        this.minutes = minutes;
        this.seconds = seconds;
    }
}
